import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import usePageTitle from "@/lib/usePageTitle";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  usePageTitle("Anmeldung wird verarbeitet");
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;
    const dest = sessionStorage.getItem("tonneva_post_login") || "/me";
    sessionStorage.removeItem("tonneva_post_login");

    if (!sessionId) {
      navigate("/login");
      return;
    }

    (async () => {
      try {
        const tenantSlug = sessionStorage.getItem("tonneva_tenant_slug");
        const payload = { session_id: sessionId };
        if (tenantSlug) payload.tenant_slug = tenantSlug;
        sessionStorage.removeItem("tonneva_tenant_slug");
        const res = await api.post("/auth/session", payload);
        if (res.data?.user) {
          setUser(res.data.user);
        }
        navigate(dest, { replace: true, state: { user: res.data.user } });
      } catch (e) {
        console.error("auth/session failed", e);
        navigate("/login");
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--tonneva-bg)]">
      <div className="text-center">
        <div className="inline-block h-10 w-10 border-2 border-[var(--tonneva-primary)] border-t-transparent rounded-full animate-spin" />
        <p className="mt-4 text-sm text-[var(--tonneva-muted)]">Anmeldung wird verarbeitet…</p>
      </div>
    </div>
  );
}
